const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("GA tables", "uipress-pro"),
  moduleName: "uip-google-analytics-tables",
  description: __("Outputs your choice of tables and options on what data to display", "uipress-pro"),
  category: __("Analytics", "uipress-pro"),
  group: "analytics",
  icon: "table_chart",
};
